import React from 'react';

const Buy = () => {
    return(
        <div className="button">Sell</div>
    );
}

export default Buy;